export default __webpack_public_path__ + "static/media/close-gray.f983ec60.svg";